import * as React from 'react';



export default class Requests extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 23 22" fill="none">
       <path d="M3 5H2C1.44772 5 1 5.44772 1 6V20C1 20.5523 1.44772 21 2 21H16.5C17.0523 21 17.5 20.5523 17.5 20V19.5" stroke="white" strokeWidth="1"/>
        <mask id="path-2-inside-1_2_169" fill="white">
        <rect x="4.5" width="18" height="18" rx="1"/>
        </mask>
        <rect x="4.5" width="18" height="18" rx="1" stroke="white" strokeWidth="1.5" mask="url(#path-2-inside-1_2_169)"/>
        <path d="M10.733 14V3.81818H14.1733C14.9688 3.81818 15.6217 3.95407 16.1321 4.22585C16.6425 4.49432 17.0204 4.86387 17.2656 5.33452C17.5109 5.80516 17.6335 6.34044 17.6335 6.94034C17.6335 7.54025 17.5109 8.07221 17.2656 8.53622C17.0204 9.00024 16.6442 9.36482 16.1371 9.62997C15.63 9.89181 14.982 10.0227 14.1932 10.0227H11.4091V8.90909H14.1534C14.697 8.90909 15.1345 8.82955 15.4659 8.67045C15.8007 8.51136 16.0426 8.28598 16.1918 7.99432C16.3442 7.69934 16.4205 7.34801 16.4205 6.94034C16.4205 6.53267 16.3442 6.17637 16.1918 5.87145C16.0393 5.56652 15.7957 5.3312 15.4609 5.16548C15.1262 4.99645 14.6837 4.91193 14.1335 4.91193H11.9659V14H10.733ZM15.5256 9.42614L18.0312 14H16.5994L14.1335 9.42614H15.5256Z" fill="white" strokeWidth="0.5"/>
      </svg>
    )
  }
}
